import { useNavigate } from "react-router-dom";
import { useModalControl } from "../../customHooks/useModalControl";
import { getTimeAgo } from "../../helperFunctions";
import { useToggleAcceptOfficialInviteMutation } from "../../redux/features/cooperative/cooperative.api";
import { SingleCooperativeInvite } from "../../redux/features/cooperative/cooperative.type";
import { Button } from "../buttons/button";
import { Icon } from "../icons/icon";
import { DeclineInvitationModal } from "../modals/app_modals/declineInvitationModal";
import { CooperativeProfilePic } from "../profile/cooperativePicture";
import { ProfilePicture } from "../profile/profilePicture";
import { ContainerCard } from "./containerCard";

export const InvitationCard = ({
  invitation,
  onSuccess,
}: {
  invitation: SingleCooperativeInvite;
  onSuccess: () => void;
}) => {
  const navigate = useNavigate();

  const { modal, modalOpen, handleModalClose, handleModalOpen } =
    useModalControl();

  const [acceptOfficialInvite, { isLoading }] =
    useToggleAcceptOfficialInviteMutation();

  return (
    <>
      <ContainerCard className="!px-6 md:!px-8 !py-6 !max-w-[526px] flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <ProfilePicture className="w-[32px] h-[32px]" tempSrc={""} />

          <Icon
            svg="left-arrow"
            width={20}
            height={20}
            className="rotate-180"
          />

          <CooperativeProfilePic
            cooperative={invitation?.Cooperative}
            className="!w-[32px] !h-[32px] !text-[12px]"
          />
        </div>

        <p className=" text-base">
          You were invited to join{" "}
          <span className="text-pry-green-200 font-medium">
            {invitation?.Cooperative?.CoopName}
          </span>{" "}
          as{" "}
          <span className="text-pry-green-200 font-medium">
            {invitation?.InvitationAction !== "official"
              ? "a member"
              : `an official (${invitation.data})`}
          </span>
          <br />
          <span className="min-w-max text-xs opacity-50">
            {`${getTimeAgo(invitation?.DateUpdated)}`}
          </span>
        </p>

        {!invitation?.ismember && (
          <div className=" text-sm">
            <ul className="list-disc leading-6 list-inside">
              <li>Complete a membership form</li>
              {invitation.isPaymentRequired ? (
                <li>Pay your membership fee</li>
              ) : undefined}
            </ul>
          </div>
        )}

        <div className="grid grid-cols-2 gap-2 ">
          <Button
            text="Decline"
            onClick={() => {
              handleModalOpen("rejectInvitationModal");
            }}
            type="button"
            className="md:!py-2"
            loading={false}
            disabled={false}
            variation="secondary-light-2"
          />

          <Button
            text="Accept Invitation"
            onClick={async () => {
              if (!invitation?.ismember) {
                navigate(
                  `/app/cooperative/${encodeURIComponent(
                    invitation.Cooperative.CoopName
                  )}/${invitation?.Cooperative?.id}/join?payment=${
                    invitation.isPaymentRequired ?? true
                  }`
                );
              } else if (
                invitation?.ismember &&
                invitation?.InvitationAction === "official"
              ) {
                const resp = await acceptOfficialInvite({
                  coop: invitation?.Cooperative?.id,
                  isAccept: true,
                });

                if (resp.data?.success) {
                  onSuccess();
                }
              }
            }}
            type="button"
            className="md:!py-2"
            loading={isLoading}
            disabled={isLoading}
            variation="primary"
          />
        </div>
      </ContainerCard>

      <DeclineInvitationModal
        isModalOpen={modalOpen && modal === "rejectInvitationModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        cooperative={invitation?.Cooperative}
        invitation={invitation}
        onSuccess={() => {
          onSuccess();
          handleModalClose();
        }}
      />
    </>
  );
};
